import { api } from './networkService';

class CityService {
    static async fetchCities(page, filters) {
        try {
            const response = await api.get(`api/user/city`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch city error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/city`);
            return response.data;
        } catch (error) {
            console.error('Fetch city error:', error);
            throw error;
        }
    }

    static async addCity(city) {
        try {
            const response = await api.post(`api/user/city`, city);
            return response;
        } catch (error) {
            console.error('Add city error:', error);
            throw error;
        }
    }

    static async updateCity(city) {
        try {
            const { id, ...info } = city;
            const response = await api.put(`api/user/city/${id}`, info);
            return response;
        } catch (error) {
            console.error('Update city error:', error);
            throw error;
        }
    }

    static async deleteCity(id) {
        try {
            const response = await api.delete(`api/user/city/${id}`);
            return response;
        } catch (error) {
            console.error('Delete city error:', error);
            throw error;
        }
    }
}

export default CityService;
